<template>
  <div>
    <div class="listing-products">
      <ul class="listing-products__list">
        <li v-for="(item, index) in items" :key="index">
          <div class="listing-products__item">
            <ListingProduct :product="item" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  items: Array,
})
</script>

<script>
export default {
  name: 'ListingProducts',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
